/** The visible session rule and the submitted rule must use the same precedence. */
export function resolveVehicleAxleLimitEnforcement(
  sessionValue: boolean | null | undefined,
  equipmentConfig: { enforceAxleLimits?: boolean | null } | string | null | undefined,
  companyDefault: boolean | null | undefined,
): boolean {
  const equipmentValue = equipmentConfig && typeof equipmentConfig === 'object' ? equipmentConfig.enforceAxleLimits : undefined
  return (sessionValue ?? equipmentValue ?? companyDefault ?? true) !== false
}
